export const downloadBlob = (blob: Blob, fileName: string): Promise<void> => {
  return new Promise<void>((resolve) => {
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = fileName;
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    resolve();
  });
};
